export default function formatDate(now) { 
    let s=new Date(now)
    var year=s.getFullYear(); 
    console.log(year)
    var month=s.getMonth()+1; 
    var date=s.getDate(); 
    var hour=s.getHours(); 
    var minute=s.getMinutes(); 
    var second=s.getSeconds(); 
    let a =1
    if(date<10){
        date="0"+date
    }
    if(hour<10){
        hour="0"+hour
    }
    if(minute<10){
        minute="0"+minute
    }
    if(second<10){
        second="0"+second
    }
    
    return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second; 
} 


// WEBPACK FOOTER //
// ./src/utils/timeStr.js